module.exports = __webpack_public_path__ + "static/media/LFB.2873d8d5.png";